import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer1PrzygotowanieDokumentacji from "../../components/offer/1przygotowanieDokumentacji";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Wnioski o zezwolenie na wycinkę drzew i dokumentacja | Gdańsk, Gdynia, Kartuzy</title>
        <meta name="title" content="Wnioski o zezwolenie na wycinkę drzew i dokumentacja | Gdańsk, Gdynia, Kartuzy" />
        <meta
          name="description"
          content="Pomagamy w załatwieniu formalności i przygotowujemy wnioski o zezwolenie na wycinkę drzew. Obsługujemy inwestycje w Gdańsku, Gdyni, Wejherowie i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Wnioski o zezwolenie na wycinkę drzew i dokumentacja | Gdańsk, Gdynia, Kartuzy"
        />
        <meta
          property="og:description"
          content="Pomagamy w załatwieniu formalności i przygotowujemy wnioski o zezwolenie na wycinkę drzew. Obsługujemy inwestycje w Gdańsku, Gdyni, Wejherowie i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer1PrzygotowanieDokumentacji />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
